export const GETFISCALREPORTACT = "GETFISCALREPORTACT";
export const GETFISCALREPORTDEAD = "GETFISCALREPORTDEAD";